import { render, staticRenderFns } from "./deliveryareaIng_new.vue?vue&type=template&id=6f54caf0&scoped=true"
import script from "./deliveryareaIng_new.vue?vue&type=script&lang=js"
export * from "./deliveryareaIng_new.vue?vue&type=script&lang=js"
import style0 from "./deliveryareaIng_new.vue?vue&type=style&index=0&id=6f54caf0&prod&lang=css"
import style1 from "./deliveryareaIng_new.vue?vue&type=style&index=1&id=6f54caf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54caf0",
  null
  
)

export default component.exports